import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'

export const getOrderDeleteRequests = createAsyncThunk(
  'orderDeleteRequests/get',
  async (...args) => {
    try {
      const axios = useAxios()
      const { data } = await axios.get('/api/orderdelreq/')
      return data
    } catch (error) {
      const { rejectWithValue } = args[1]
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const saveOrderDeleteRequest = createAsyncThunk(
  'orderDeleteRequest/save',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const { data } = await axios.put(`/api/orderdelreq/${t.id}/`, t, config)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const createOrderDeleteRequest = createAsyncThunk(
  'orderDeleteRequest/create',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/orderdelreq/', t)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const deleteOrderDeleteRequest = createAsyncThunk(
  'orderDeleteRequest/delete',
  async (t, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/orderdelreq/${t.id}/`)
      return data
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)
